// ── PHONE NUMBER ───────────────────────────────────────────────
// The ONLY place the phone number lives. Enter it like '(702) 555-0123'.
// While empty, every phone button reads "Phone number coming soon".
export const PHONE_NUMBER = ''

// ── LOGO IMAGE ─────────────────────────────────────────────────
// Paste a full image URL here to replace the typeset hero emblem with a logo.
export const LOGO_IMAGE_URL = ''

const phoneDigits = PHONE_NUMBER.replace(/\D/g, '')

// nightly demo reset
export const business = {
  name: 'Oh My Tacos',
  tagline: 'Auténtica comida mexicana — street tacos, burritos & quesadillas made fresh at the window.',
  phoneDisplay: PHONE_NUMBER || 'Phone number coming soon',
  phoneHref: phoneDigits ? `tel:${phoneDigits}` : undefined,
  todayStop: 'Las Vegas, NV',
  todayHours: '11am – 8pm',
}

// `days` uses JS day numbers (0 = Sunday) to highlight today's row.
export const schedule = [
  { day: 'Tue – Thu', hours: '11am – 8pm', days: [2, 3, 4] },
  { day: 'Fri – Sat', hours: '11am – 10pm', days: [5, 6] },
  { day: 'Sunday', hours: '12pm – 6pm', days: [0] },
  { day: 'Monday', hours: 'Closed', days: [1] },
]

export const notices = [
  'Call ahead and your order will be ready at the window.',
  'Catering & private events available — just give us a call.',
  '*Prices may change without notice due to changing food costs*',
]
